module.exports = __webpack_public_path__ + "img/packages-icon.7567ff80.svg";